var Handlebars = require("../../../../../node_modules/.pnpm/handlebars@4.7.10/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"infoboard-title\" style=\"margin-top: -16px;\">"
    + alias2(__default(require("./i18n.js")).call(alias1,"Common.Information",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":56},"end":{"line":1,"column":85}}}))
    + "</div>\n<fieldset>\n    <section class=\"form-group\">\n        <div class=\"col-sm-12\">\n            <label class=\"form-label\">"
    + alias2(__default(require("./i18n.js")).call(alias1,"Common.Name",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":5,"column":38},"end":{"line":5,"column":60}}}))
    + "</label>\n            <input type=\"text\" class=\"form-control flat\" maxlength=\"255\" placeholder=\""
    + alias2(__default(require("./i18n.js")).call(alias1,"Common.Name",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":6,"column":86},"end":{"line":6,"column":108}}}))
    + "\"\n                   name=\"Name\" value=\""
    + alias2(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"information") : depth0)) != null ? lookupProperty(stack1,"name") : stack1), depth0))
    + "\" required/>\n        </div>\n    </section>\n</fieldset>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/scripts/core/templates/templates/points-edit-information.hbs
// module id = buz0
// module chunks = 1